import {axiosInstance} from "@/plugins/axios";
import {Supplier} from "../modules/suppliers/types";
export interface SupplierPayload {
  offset: null,
  limit: null,
  search: null,
  country_code?: string
}

export async function getSupplier(id: string) {
  const response = await axiosInstance.get(`suppliers/${id}`);
  return response.data;
}

export async function saveSupplier(supplier: Supplier) {
  await axiosInstance.post(`roles/supplier`, supplier);
}

export async function updateSupplier(supplier: Supplier) {
  await axiosInstance.put(`suppliers/${supplier.id}`, supplier);
}

export async function getSuppliers(payload: SupplierPayload) {
  let url = 'suppliers?';
  if (payload.limit) {
    url += `limit=${payload.limit}&`;
  }

  if (payload.offset) {
    url += `offset=${payload.offset}&`;
  }

  if (payload.country_code) {
    url += `country_code=${payload.country_code}&`;
  }

  if (payload.search) {
    url += `search=${payload.search}`;
  }
  const response = await axiosInstance.get(url);
  return response.data;
}

